import React from 'react';
import { Grid, Row, Col, Panel, FormGroup, Checkbox, Button, Radio } from 'react-bootstrap';
import { handleHttpResponse } from '../../lib/Helpers';
import User from '../../lib/User';
import { Link } from 'react-router-dom'

class UserSearchSnapshot extends React.Component {
  getStyles(){
    return {
      container: {
        display: 'flex',
        marginTop: '5px',
        cursor: 'pointer'
      }
    }
  }

  render() {
    const styles = this.getStyles();
    const user = new User(this.props.user);
    return(
      <div style={styles.container}>
        <img style={{height: '50px'}} src={user.profileImage(50)} />
        <Link style={{paddingTop: '10px', paddingLeft: '10px'}} to={'/users/'+user.swipecast_user_id}>
          {user.full_name}
        </Link>
        <div style={{paddingTop: '10px', paddingLeft: '10px'}}>- {user.profiles.length > 0 ? user.profiles[0].profile_type : ''} at {user.organization || 'N/A'}</div>
      </div>
    )
  }
}

export default UserSearchSnapshot;